const rawApiUrl = process.env.REACT_APP_API_URL?.trim() ?? "";

const normalizeApiUrl = (value) => {
	if (!value) {
		return "";
	}

	const withProtocol = /^https?:\/\//i.test(value)
		? value
		: `https://${value.replace(/^\/+/, "")}`;

	return withProtocol.endsWith("/") ? withProtocol : `${withProtocol}/`;
};

export const API_URL = normalizeApiUrl(rawApiUrl);

export const buildApiUrl = (path = "") => {
	if (!API_URL) {
		throw new Error("API nao configurada. Defina REACT_APP_API_URL.");
	}

	const normalizedPath = path.startsWith("/") ? path.slice(1) : path;
	return `${API_URL}${normalizedPath}`;
};

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const TENANT_ID = process.env.REACT_APP_TENANT_ID?.trim() ?? "";

export const SECRETARY_NAME =
	process.env.REACT_APP_SECRETARYNAME?.trim() ||
	"SECRETARIO NAO INFORMADO, ENTRAR EM CONTATO COM O SUPORTE";

export const APP_NAME = "SIGA";

export const EMPENDENCIA =
	["true", "1"].includes(
		(process.env.REACT_APP_EMPENDENCIA ?? "").trim().toLowerCase(),
	);